import React from 'react';
import { useTheme } from "../contexts/ThemeContext";
import { THEMES, THEME_COLORS } from "../components/Constants";

export default function AccountSelectorList({ accounts, selectedId, onSelect, isSource, title }) {
    const { currentTheme } = useTheme();
    const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS[THEMES.BLUE];
    
    const styles = {
        container: { 
            maxHeight: '200px', 
            overflowY: 'auto', 
            border: `1px solid ${themeColors.inputBorder}`, 
            padding: '5px',
            borderRadius: '4px',
            backgroundColor: themeColors.inputBackground,
        },
        accountItem: (isSelected, isSource) => ({
            padding: '10px',
            margin: '5px 0',
            cursor: 'pointer',
            borderRadius: '4px',
            transition: 'background-color 0.15s, border-color 0.15s',
            // Utilisation des couleurs de thème : primary pour source (débiteur), success pour destination (créancier)
            backgroundColor: isSelected ? (isSource ? themeColors.primary + '20' : themeColors.success + '20') : 'transparent',
            border: isSelected ? `1px solid ${isSource ? themeColors.primary : themeColors.success}` : `1px solid ${themeColors.inputBorder}50`,
            color: themeColors.text,
            fontWeight: isSelected ? 'bold' : 'normal',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }),
        accountName: { flexGrow: 1 },
        unmanagedTag: {
            backgroundColor: themeColors.corbeilleBG,
            color: themeColors.corbeilleText,
            padding: '3px 8px',
            borderRadius: '3px',
            fontSize: '0.8em',
        }
    };

    if (accounts.length === 0) {
        return (
            <div>
                <h4 style={{color: themeColors.secondary}}>{title}</h4>
                <p style={{ color: themeColors.danger, padding: '10px', fontSize: '0.9em' }}>Aucun compte disponible pour la sélection.</p>
            </div>
        );
    }

    const unmanagedAccountName = "Aucun compte n'est à renseigner";

    return (
        <div style={styles.container}>
            <h4 style={{color: themeColors.secondary, margin: '5px 0'}}>{title}</h4>
            {accounts.map((account) => (
                <div
                    key={account.id}
                    onClick={() => onSelect(account.id)}
                    style={styles.accountItem(selectedId === account.id, isSource)}
                >
                    <span style={styles.accountName}>
                        {account.id === -99 ? (
                            <span>{unmanagedAccountName}</span>
                        ) : (
                            `${account.name} (${account.personName})`
                        )}
                    </span>
                </div>
            ))}
        </div>
    );
}